import { isRunningInApp } from '@/utilities/sizeUtils';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';
import { StreamChat } from 'stream-chat';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export default async function registerDevice(client: StreamChat) {
  const configValid = validateConfig();
  if (!configValid) {
    return;
  }
  const app = initializeApp(firebaseConfig);
  const messaging = getMessaging(app);
  let workerRegistration: ServiceWorkerRegistration | undefined = undefined;

  async function registerDeviceToken(client: StreamChat) {
    const token = await getToken(messaging, {
      vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: workerRegistration,
    });
    await client.addDevice(token, 'firebase', undefined, import.meta.env.VITE_GETSTREAMIO_PUSH_PROVIDER);
  }

  function validateConfig() {
    for (const [key, value] of Object.entries(firebaseConfig)) {
      if (value == undefined) {
        console.log('Cannot register device in firebase, missing config key: ', key);
        return false;
      }
    }
    if (import.meta.env.VITE_FIREBASE_VAPID_KEY == undefined) {
      console.log('Missing firebase vapid key');
      return false;
    }
    return true;
  }

  async function initializeFirebaseSw() {
    workerRegistration = await navigator.serviceWorker.ready;
    workerRegistration.active?.postMessage({
      type: 'INIT_FIREBASE',
      payload: firebaseConfig,
    });
  }

  function registerSwInitListener() {
    navigator.serviceWorker.addEventListener('message', async (event) => {
      if (event.data.type !== 'FIREBASE_INIT_DONE') {
        return;
      }
      await registerDeviceToken(client);
    });
  }

  try {
    // do not install firebase serviceworker in mobilapp
    if (!isRunningInApp() && 'serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.getRegistration();
      registerSwInitListener();
      if (registration) {
        await initializeFirebaseSw();
        return;
      }
      await navigator.serviceWorker.register('/firebase-messaging-sw.js');
      await initializeFirebaseSw();
    }
  } catch (err) {
    console.error('Error getting FCM token:', err);
  }
}
